<template>
  <b-modal id="mdl-det" ref="modal" size="lg" title="Detail" hide-footer @show="setData" @hide="resetData">

      <div class="form-row">
        <label class="col-md-2">Date Range Leave</label>
        <div class="col-md-3 mb-3">
            {{data.date}}
        </div>
      </div>
      <div class="form-row">
        <label class="col-md-2"></label>
        <div class="col-md-2 mb-3">
          {{data.start}} to  {{data.end}}
        </div>
      </div>
      <div class="form-row">
        <label class="col-md-2" >Remarks</label>
        <div class="col-md-9 mb-3">
          {{ data.reason }}
        </div>
      </div>
    <hr>

    <template v-if="data.stat_id !== 0">
      <div class="form-group">
        <label class="control-label">Approval Information</label>
        <div class="table-responsive">
          <table class="table table-hover table-striped" aria-label="Approval Information">
            <thead>
            <tr>
              <th style="min-width:10px" id="level"> Level </th>
              <th id="name"> Name </th>
              <th id="email"> Email </th>
              <th id="status"> Status </th>
              <th id="date"> Date </th>
            </tr>
            </thead>
            <tbody >
            <tr v-for="(data, i) in list_supervisor">
              <td>{{data.level}}</td>
              <td>{{data.name}}</td>
              <td>{{data.email}}</td>
              <td>{{data.status_name}}</td>
              <td>{{data.status_date}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <list-supervisor module="overtime" v-else-if="this.$store.getters.companySettings.is_ot_auto_approve == 0"></list-supervisor>
  </b-modal>
</template>

<script>
import {BModal} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "@/components/pages/employee/ListSupervisor";

export default {
  name: "OvertimeDetail",
  components:{
    BModal,
    ListSupervisor
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      list_supervisor:[]
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          if(this.data.leave_stat_id !== 0) this.getListSupervisor()
        }
      }, 100)
    },
    getListSupervisor(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.overtime.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    resetData(){
      this.$parent.data = {}
    }
  }
}
</script>